/*
 * store.js
 *
 * Description: Holds common/global Stores.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021,2022 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import Vue from 'vue';
import Vuex from 'vuex';
import booking from './modules/booking/booking'; // 'Booking:Store'
import services from './modules/services/services'; // 'Services:Store'
import rebooking from './modules/rebooking/rebooking'; // 'Rebooking:Store'
import auth from './modules/auth/auth'; // 'Auth:Store'
import travelcenter from './modules/travelcenter/travelcenter'; // 'Travelcenter:Store'
import career from './modules/career/career'; // 'Career:Store'
import covid from './modules/covid/covid'; // 'Covid:Store'
import infoalert from './modules/infoalert/infoalert'; // 'Infoalert:Store'
import pressreleases from './modules/pressreleases/pressreleases'; // 'Pressreleases:Store'
import flightstatus from './modules/flightstatus/flightstatus'; // 'Flightstatus:Store'

import * as getters from './getters'; // global ones
import * as mutations from './mutations';
import * as actions from './actions';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        // >>> just demo
        value: 0,
    },
    getters,
    mutations,
    actions,
    modules: {
        booking,
        services,
        rebooking,
        auth,
        travelcenter,
        career,
        covid,
        infoalert,
        pressreleases,
        flightstatus
    },
});



// WEBPACK FOOTER //
// ./src/store/store.js